<template>
  <div
    class="profile-selector-avatar"
    :class="[{ [`profile-selector-avatar--${size}`]: true, 'profile-selector-avatar--with-initials': !avatarUrl }]"
  >
    <NuxtImg
      v-if="avatarUrl"
      :src="avatarUrl"
      :alt="`${name}'s profile'`"
      :height="imageSize"
      :width="imageSize"
      preset="face"
      fit="fill"
    />
    <BravadoText v-else tag="p" variant="caption1-semibold">{{ initials }}</BravadoText>
  </div>
</template>

<script lang="ts" setup>
import { computed } from '@nuxtjs/composition-api';

type ProfileSelectorAvatarProps = {
  name: string;
  size?: 'sm' | 'md';
  avatarUrl?: string | null;
};

const props = withDefaults(defineProps<ProfileSelectorAvatarProps>(), {
  size: 'sm',
  avatarUrl: null,
});

const initials = computed(() => props.name.substring(0, 1).toLocaleUpperCase());
const imageSize = computed(() => (props.size === 'sm' ? 24 : 32));
</script>

<style lang="scss" scoped>
.profile-selector-avatar {
  border-radius: 50%;
  overflow: hidden;
  background-color: var(--theme-color-border);
  flex-shrink: 0;

  &--with-initials {
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--gray-50);
  }

  &--sm {
    height: 24px;
    width: 24px;
  }

  &--md {
    height: 32px;
    width: 32px;
  }
}
</style>
